import { colors } from "../../../tokens/color";
import { fontWeights } from "../../../tokens/typography";
import { formControlStyles, defaultColor, formControlFontSizeStyles } from '../formControlStyles';
export const selectStyles = {
    ...formControlStyles,
    removeCheckbox: {
        '& .MuiCheckbox-root': {
            display: 'none',
        },
    },
    menuItem: {
        ...formControlFontSizeStyles,
        color: colors.core.blackTarr,
        '&:hover': {
            backgroundColor: colors.core.cloud,
            color: colors.core.blackTarr,
        },
        '&.Mui-selected': {
            backgroundColor: colors.core.cloud,
            color: colors.core.blackTarr,
        },
        '& .MuiCheckbox-root': {
            display: 'inline-flex',
        },
    },
    nativeHiddenPlaceholder: {
        '& > .MuiNativeSelect-select': {
            color: 'transparent !important',
        },
    },
    nativeOption: {
        color: colors.core.blackTarr,
    },
    selectIcon: (color = defaultColor) => ({
        '& path': {
            fill: color,
        },
    }),
    groupHeading: {
        ...formControlFontSizeStyles,
        color: colors.core.deepSpace,
        fontWeight: fontWeights.bold,
    },
};
